<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
        <circle cx="12" cy="7" r="4"></circle>
      </svg>
    </div>
    <h2 class="dialog-title">{{ titre }}</h2>
    <button type="button" class="btn-icon" mat-dialog-close>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>

  <form [formGroup]="expediteurForm" (ngSubmit)="onSubmit()">
    <div class="dialog-body" *ngIf="!chargement">
      <div class="form-grid">
        <div class="form-group">
          <label class="form-label">Nom <span class="required">*</span></label>
          <input 
            class="form-input" 
            [class.error]="expediteurForm.get('nom')?.invalid && expediteurForm.get('nom')?.touched"
            type="text" 
            placeholder="Ex: Kouassi" 
            formControlName="nom">
          <span class="error-text" *ngIf="expediteurForm.get('nom')?.invalid && expediteurForm.get('nom')?.touched">
            Requis
          </span>
        </div>
        <div class="form-group">
          <label class="form-label">Prénoms <span class="required">*</span></label>
          <input 
            class="form-input" 
            [class.error]="expediteurForm.get('prenom')?.invalid && expediteurForm.get('prenom')?.touched"
            type="text" 
            placeholder="Ex: Jean-Marc" 
            formControlName="prenom">
          <span class="error-text" *ngIf="expediteurForm.get('prenom')?.invalid && expediteurForm.get('prenom')?.touched">
            Requis
          </span>
        </div>
        <div class="form-group full-width">
          <label class="form-label">Téléphone <span class="required">*</span></label>
          <input 
            class="form-input" 
            [class.error]="expediteurForm.get('telephone')?.invalid && expediteurForm.get('telephone')?.touched"
            type="text" 
            mask="99-99-99-99-99" 
            placeholder="07-07-07-07-07" 
            formControlName="telephone">
          <span class="error-text" *ngIf="expediteurForm.get('telephone')?.invalid && expediteurForm.get('telephone')?.touched">
            10 chiffres requis
          </span>
        </div>
      </div>
    </div>

    <div *ngIf="chargement" class="chargement-container">
      <div class="spinner"></div>
      <p>Traitement en cours...</p>
    </div>

    <div class="dialog-actions" *ngIf="!chargement">
      <button type="button" class="btn btn-secondary" mat-dialog-close>Annuler</button>
      <button type="submit" class="btn btn-primary" *ngIf="voirBtnEnregistrer">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
          <polyline points="20 6 9 17 4 12"></polyline>
        </svg>
        {{ data.typeOperation === 'ajout' ? 'Enregistrer' : 'Modifier' }}
      </button>
    </div>
  </form>
</div>


